import commonConstant from "@/constants/commonConstant";
import * as Timeline from "@/seed/constants/timeline";
import { STATUS } from "@/seed/constants/timeline";
import { getRoundInfo } from "@/seed/repository/poolEvent";
import moment from "moment-timezone";
import { checkTimeline } from "./common";
import { ethers } from "ethers";
import { data as tokenSaleConfig } from "@/seed/shared/token/token-sale";

export const getTimeline = (poolEvent) => {
    const upcomingStart = moment(poolEvent.competitionPeriodStartAt || "");
    const upcomingEnd = moment(poolEvent.competitionPeriodEndAt ?? "");
    const whitelistStart = moment(poolEvent.whitelistPeriodStartAt ?? "");
    const whitelistEnd = moment(poolEvent.whitelistPeriodEndAt ?? "");
    const purchaseStart = moment(poolEvent.swapTokenPeriodStartAt ?? "");
    const purchaseEnd = moment(poolEvent.swapTokenPeriodEndAt ?? "");
    const claimTokenStart = moment(poolEvent.claimTokenPeriodStartAt ?? "");
    const whitelistResultDate = moment(poolEvent.whitelistWinnerAnnouncementAt ?? "");

    // console.log("moment", isNaN(moment("")));
    // console.log("moment", isNaN(upcomingStart));
    console.log("moment", moment("").valueOf());

    console.log("upcomingStart", upcomingStart.format(commonConstant.FORMAT_DATE_YMD_HMS));

    const primaryTimelineConfig = {
        [Timeline.STEP_WHITELIST]: {
            milestone: Timeline.STEP_WHITELIST,
            // milestone for calculation
            start: whitelistStart.valueOf(),
            end: whitelistEnd.valueOf(),
            [STATUS.BEFORE]: {
                from: NaN,
                to: whitelistStart.valueOf(),
                step: Timeline.STEP_UPCOMING,
            },
            [STATUS.INPROGRESS]: {
                from: whitelistStart.valueOf(),
                to: whitelistEnd.valueOf(),
                step: Timeline.STEP_WHITELIST,
                // TODO: others status will process and update later
            },
            [STATUS.AFTER]: {
                from: NaN,
                // to: purchaseStart.valueOf(),
                // MUST update when whitelist result be updated from BE
                to: whitelistResultDate.valueOf(),
                step: Timeline.STEP_WHITELIST_CLOSE,
            },
        },
        [Timeline.STEP_PURCHASE]: {
            milestone: Timeline.STEP_PURCHASE,
            start: purchaseStart.valueOf(),
            end: purchaseEnd.valueOf(),
            // Before
            [STATUS.BEFORE]: {
                from: NaN,
                to: purchaseStart.valueOf(),
                step: Timeline.STEP_WHITELIST_CLOSE,
            },
            // During
            [STATUS.INPROGRESS]: {
                from: purchaseStart.valueOf(),
                to: purchaseEnd.valueOf(),
                step: Timeline.STEP_PURCHASE,
                // TODO: others status will process and update later
            },
            // After
            [STATUS.AFTER]: {
                from: NaN,
                to: NaN,
                step: Timeline.STEP_PURCHASE_CLOSE,
            },
        },
    };

    // TODO: check purchaseStart, purchaseEnd isNaN
    const whitelistTimeline = checkTimeline(whitelistStart, whitelistEnd);
    let purchaseTimeline = checkTimeline(purchaseStart, purchaseEnd);

    if (isNaN(purchaseStart) || isNaN(purchaseEnd)) {
        purchaseTimeline = STATUS.BEFORE;
    }

    let currentTimeObj;
    let currStatus = STATUS.BEFORE;
    let primaryTimeline = Timeline.STEP_PURCHASE;

    switch (whitelistTimeline + purchaseTimeline) {
        // ====
        // Purchase Phrase
        case STATUS.AFTER + STATUS.AFTER:
            currStatus = purchaseTimeline;
            currentTimeObj = primaryTimelineConfig[Timeline.STEP_PURCHASE][currStatus];
            break;
        case STATUS.AFTER + STATUS.INPROGRESS:
            currStatus = purchaseTimeline;
            currentTimeObj = primaryTimelineConfig[Timeline.STEP_PURCHASE][currStatus];
            break;
        // ====
        // Whitelist Phrase
        case STATUS.AFTER + STATUS.BEFORE:
            currStatus = whitelistTimeline;
            primaryTimeline = Timeline.STEP_WHITELIST;
            currentTimeObj = primaryTimelineConfig[Timeline.STEP_WHITELIST][currStatus];
            break;

        case STATUS.INPROGRESS:
            currStatus = whitelistTimeline;
            primaryTimeline = Timeline.STEP_WHITELIST;
            currentTimeObj = primaryTimelineConfig[Timeline.STEP_WHITELIST][currStatus];
            break;
        case STATUS.BEFORE:
            currStatus = whitelistTimeline;
            primaryTimeline = Timeline.STEP_WHITELIST;
            currentTimeObj = primaryTimelineConfig[Timeline.STEP_WHITELIST][currStatus];
            break;

        default:
            primaryTimeline = Timeline.STEP_WHITELIST;
            currentTimeObj = primaryTimelineConfig[Timeline.STEP_WHITELIST][whitelistTimeline];
            break;
    }

    console.log("getTimeline", {
        currentTimeObj,
        currStatus,
        whitelistTimeline,
        purchaseTimeline,
    });

    return {
        timeline: {
            upcomingStart,
            upcomingEnd,
            whitelistStart,
            whitelistEnd,
            purchaseStart,
            purchaseEnd,
            claimTokenStart,
            whitelistResultDate,
        },
        countdown: {
            from: currentTimeObj.from,
            to: currentTimeObj.to,
            tba: isNaN(currentTimeObj.from) && isNaN(currentTimeObj.to),
        },
        primaryTimeline: primaryTimeline,
        currentTimelineStep: currentTimeObj.step,
        currentTimelineStatus: currStatus,
    };
};

/**
 *
 *
 * @param {*} currentTimelineStep
 * @returns
 */
export const getLayoutContent = (currentTimelineStep) => {
    console.log("getLayoutContent", currentTimelineStep);
    switch (currentTimelineStep) {
        // ====
        // Upcoming Phrase
        case Timeline.STEP_UPCOMING:
            return tokenSaleConfig.upComing;

        // ====
        // Whitelist Phrase
        case Timeline.STEP_WHITELIST:
            return tokenSaleConfig.whitelistOpen;
        case Timeline.STEP_WHITELIST_CLOSE:
            // TODO: update layout when whitelist result has updated
            return tokenSaleConfig.whitelistClose;

        case Timeline.STEP_WHITELIST_WIN:
            return tokenSaleConfig.whitelistWin;

        case Timeline.STEP_WHITELIST_FAIL:
            return tokenSaleConfig.whitelistFail;

        // ====
        // Purchase Phrase
        case Timeline.STEP_PURCHASE:
            return tokenSaleConfig.tokenPurchase;
        case Timeline.STEP_PURCHASE_SUCCESS:
            return tokenSaleConfig.tokenPurchaseSuccess;
        case Timeline.STEP_PURCHASE_CLOSE:
            return tokenSaleConfig.tokenPurchaseClose;
        default:
            return tokenSaleConfig.upComing;
    }
};

export const getWhitelistResultContent = (saleEvent, layoutContentDef) => {
    if (
        saleEvent?.totalWinners &&
        saleEvent?.whitelistResultLink &&
        layoutContentDef.tokenSaleHero.whitelistResult
    ) {
        const whitelistResult = layoutContentDef.tokenSaleHero.whitelistResult;
        whitelistResult.price = saleEvent.salePrice + " " + saleEvent.acceptedCurrency; // saleEvent.acceptedCurrency
        whitelistResult.totalWinner.value = saleEvent.totalWinners;
        whitelistResult.checkDetails.link = saleEvent.whitelistResultLink;
        return whitelistResult;
    }
};

export const getSaleEventInfo = (poolEvent) => {
    const saleEvent = {
        saleId: poolEvent._id,
        title: poolEvent?.pool?.title ?? "",
        salePrice: poolEvent?.contributeAmountToken, // in BUSD
        acceptedCurrency: poolEvent.acceptedCurrency ?? "BNB",
        tokenSymbol: "MDN", // Received currency
        tokenPrice: poolEvent?.pricePerToken ?? 0, // Sale price (Rate)
        // estimatedReceive: 40000000, // display on form
        availableAmountToken: poolEvent?.availableAmountToken,
        // TODO: replace link
        whitelistFormLink: poolEvent.whitelistFormLink,
        whitelistResultLink: poolEvent.whitelistResultLink,
        totalWinners: poolEvent?.maxWinnerSwapToken ?? 0,
        // TODO: get from BE
        // totalWinners: poolEvent?.whitelists.length ?? 0,
        roundOverview: getRoundInfo(poolEvent, {
            acceptCurrency: poolEvent.acceptedCurrency ?? "BNB",
        }),
        // saleProgress: {
        //     soldAllocation: 20000000,
        //     totalAllocation: 40000000,
        // },
    };
    return saleEvent;
};

export const getVestingFromContract = (vestingData) => {
    if (vestingData) {
        console.log("getVestingFromContract", { vestingData });
        return {
            totalTimes: parseInt(ethers.utils.formatUnits(vestingData.times, 0)), // total vesting time
            tgeAllocation: parseFloat(ethers.utils.formatEther(vestingData.tgeAllocation)),
            totalAllocation: parseFloat(ethers.utils.formatEther(vestingData.totalAllocation)),
            allocation: parseFloat(ethers.utils.formatEther(vestingData.allocation)),
            claimableStartAt: parseInt(ethers.utils.formatUnits(vestingData.start, 0)),
            vestingDuration: parseInt(ethers.utils.formatUnits(vestingData.duration, 0)), //
            vestedAllocation: parseFloat(ethers.utils.formatEther(vestingData.vested)),
            tgeClaimed: vestingData.claimedTGEAllocation,
        };
    }
};

export const getAllocationInfo = ({
    txid,
    saleId,
    title,
    salePrice,
    tokenPrice,
    estReceiveMDN,
    contributeCurrency,
    claimableAmount,
}) => {
    return {
        saleId: saleId,
        title: title,
        txid: txid,
        contributeValue: salePrice,
        estimatedReceive: estReceiveMDN,
        tokenPrice: tokenPrice, // Sale price (Rate)
        currency: "MDN",
        contributeCurrency: contributeCurrency,
        claimableAmount: claimableAmount,
        // vestingSchedule: {
        //     total: 10, // total vesting time
        //     details: [
        //         {
        //             datetime: "",
        //             percent: 0,
        //             value: 0,
        //             claimable: false,
        //             claimed: false,
        //         },
        //     ],
        // },
    };
};

export const getDataFromContract = (seedData) => {
    if (seedData) {
        console.log("getDataFromContract", { seedData });
        // 0: balance
        // 1: hardCap
        // 2: seedPackage
        // 3: estReceiveMDN
        // 4: isWhitelisted
        // 5: isPurchased
        // 6: limitWhitelist: for all users
        return {
            // seedData()
            currentBalance: ethers.utils.formatEther(seedData[0]),
            hardCap: ethers.utils.formatEther(seedData[1]),
            // estReceiveMDN()
            estReceiveMDN: ethers.utils.formatEther(seedData[3]),
            // totalWhitelisted()
            totalWhitelistWinners: 0,
            // seedPackage()
            salePrice: ethers.utils.formatEther(seedData[2]),
        };
    }
};
